import FeatureBox from "components/conversion/FeatureBox";
import classNames from "components/ui/classNames";

interface CompanyPageCtaProps {
  displayOrigin?: string;
}
export default function CompanyPageCta({ displayOrigin }: CompanyPageCtaProps) {
  return (
    <div className="mx-auto w-full max-w-7xl">
      <div
        className={classNames(
          "flex flex-col items-center justify-center gap-y-6 rounded-xl bg-indigo-50/50 p-6",
          "dark:bg-indigo-600/5 dark:ring-slate-900 dark:ring-offset-0 dark:ring-offset-slate-900",
        )}
      >
        <div className="max-w-sm">
          <FeatureBox
            displayOrigin={displayOrigin || "Company page"}
            buttonText="Confira Aqui os Detalhes"
            callToActionText={
              <>Destrave 100% dos dados e tenha acesso imediato as informações atualizadas de mais de 6.000 ativos!</>
            }
            className="border-transparent"
            featureHighlights={[
              "Acesso completo sem restrições",
              "Histórico de dados ilimitado",
              "Vídeos de análises",
              "Destaques trimestrais",
              "Tabela customizável",
              "Ranking",
              "Discussões",
            ]}
          />
        </div>
      </div>
    </div>
  );
}
